import { findDOMNode } from 'react-dom';

export default function getContainer(container, defaultContainer) {
  // eslint-disable-next-line no-param-reassign
  container = typeof container === 'function' ? container() : container;

  // eslint-disable-next-line react/no-find-dom-node
  return findDOMNode(container) || defaultContainer;
}
